/*
 * @Descripttion: 客户回款明细页面hooks
 * @Author: 曹博
 * @Date: 2023-09-22 08:57:38
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-26 13:13:12
 */

import { useEffect, useReducer } from 'react'
import { getPlatformList, isResponseCodeSuccess } from '../../tools/util'
import { Form } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import reducer, {
  initState,
  reloadStateAction,
  setDataSourceAction,
  setFormDataAction,
  setLoadingAction,
  setPlatformListAction,
} from './reducer'
import { GET_CUSTOMER_PAYBACK_LIST } from '../../api/paymentOrder'

const UsePaymentDetailsHook = () => {
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [state, dispatch] = useReducer(reducer, initState)
  const [form] = Form.useForm()
  const { formData } = state

  // 查询回款明细
  const searchHandler = () => {
    getData(form.getFieldsValue())
  }

  // 重置搜索参数
  const resetHandler = () => {
    form.resetFields()
    getData({})
  }

  // 表单变化
  const onFieldsChange = () => {
    dispatch(setFormDataAction(form.getFieldsValue()))
  }

  // 获取回款明细
  const getData = async (params: any) => {
    dispatch(setLoadingAction(true))
    const res = await GET_CUSTOMER_PAYBACK_LIST({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setLoadingAction(false))
      dispatch(setDataSourceAction(res.data))
    } else {
      dispatch(setLoadingAction(false))
    }
  }

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
      },
    })
    dispatchRedux(action)
  }

  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  useEffect(() => {
    const flag = getpagecache()
    const platformList = getPlatformList().map((item) => {
      return {
        label: item.name,
        value: item.code,
      }
    })
    dispatch(setPlatformListAction(platformList))
    if (flag) {
      if (flag.pageState.loading) {
        form.setFieldsValue({ ...flag.pageState.formData })
        getData({ ...flag.pageState.formData })
      } else {
        dispatch(reloadStateAction(flag.pageState))
        form.setFieldsValue({ ...flag.pageState.formData })
      }
    } else {
      getData({ ...formData })
    }
  }, [])

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state])

  return {
    form,
    state,
    resetHandler,
    searchHandler,
    onFieldsChange,
  }
}

export default UsePaymentDetailsHook
/*
 * @Descripttion: 客户回款明细页面hooks
 * @Author: 曹博
 * @Date: 2023-09-22 08:57:38
 * @LastEditors: 曹博
 * @LastEditTime: 2023-09-26 13:13:12
 */

import { useEffect, useReducer } from 'react'
import { getPlatformList, isResponseCodeSuccess } from '../../tools/util'
import { Form } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import reducer, {
  initState,
  reloadStateAction,
  setDataSourceAction,
  setFormDataAction,
  setLoadingAction,
  setPlatformListAction,
} from './reducer'
import { GET_CUSTOMER_PAYBACK_LIST } from '../../api/paymentOrder'

const UsePaymentDetailsHook = () => {
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [state, dispatch] = useReducer(reducer, initState)
  const [form] = Form.useForm()
  const { formData } = state

  // 查询回款明细
  const searchHandler = () => {
    getData(form.getFieldsValue())
  }

  // 重置搜索参数
  const resetHandler = () => {
    form.resetFields()
    getData({})
  }

  // 表单变化
  const onFieldsChange = () => {
    dispatch(setFormDataAction(form.getFieldsValue()))
  }

  // 获取回款明细
  const getData = async (params: any) => {
    dispatch(setLoadingAction(true))
    const res = await GET_CUSTOMER_PAYBACK_LIST({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setLoadingAction(false))
      dispatch(setDataSourceAction(res.data))
    } else {
      dispatch(setLoadingAction(false))
    }
  }

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
      },
    })
    dispatchRedux(action)
  }

  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  useEffect(() => {
    const flag = getpagecache()
    const platformList = getPlatformList().map((item) => {
      return {
        label: item.name,
        value: item.code,
      }
    })
    dispatch(setPlatformListAction(platformList))
    if (flag) {
      if (flag.pageState.loading) {
        form.setFieldsValue({ ...flag.pageState.formData })
        getData({ ...flag.pageState.formData })
      } else {
        dispatch(reloadStateAction(flag.pageState))
        form.setFieldsValue({ ...flag.pageState.formData })
      }
    } else {
      getData({ ...formData })
    }
  }, [])

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state])

  return {
    form,
    state,
    resetHandler,
    searchHandler,
    onFieldsChange,
  }
}

export default UsePaymentDetailsHook
